import * as tslib_1 from "tslib";
/**
 * @file Timeline Plannning component
 * @author Willem Jan Weitering
 */
import { OnInit } from '@angular/core';
import { TimelineItemBaseComponent } from '../timeline-item-base/timeline-item-base.component';
import { TimelineService } from '../timeline.service';
import { LocalisationService } from '../../core/localisation.service';
/**
 * This is a component that shows a message about a planning change in the timeline.
 */
var TimelineItemPlanningComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TimelineItemPlanningComponent, _super);
    /**
     * Constructs a TimelinePlanning Component
     */
    function TimelineItemPlanningComponent(timelineService, localisationService) {
        var _this = _super.call(this, timelineService, localisationService) || this;
        _this.timelineService = timelineService;
        _this.localisationService = localisationService;
        return _this;
    }
    /**
     * Is called directly after the creation of this component
     */
    TimelineItemPlanningComponent.prototype.ngOnInit = function () {
    };
    return TimelineItemPlanningComponent;
}(TimelineItemBaseComponent));
export { TimelineItemPlanningComponent };
